const NBG_URL = "https://nbg.gov.ge/gw/api/ct/monetarypolicy/currencies/ka/json";

let cachedRates = null;
let cachedAt = 0;
const CACHE_MS = 10 * 60 * 1000; // 10 minutes

async function fetchNbgRates() {
  const now = Date.now();
  if (cachedRates && now - cachedAt < CACHE_MS) {
    return cachedRates;
  }

  const res = await fetch(NBG_URL);
  if (!res.ok) throw new Error(`NBG API returned ${res.status}`);

  const data = await res.json();
  // Response format: [{ date, currencies: [{ code, quantity, rateFormated, rate, ... }] }]
  const currencies = data?.[0]?.currencies || [];

  const rates = {};
  for (const c of currencies) {
    // rate = quantity of GEL for `quantity` units of foreign currency
    // e.g. USD: quantity=1, rate=2.7 => 1 USD = 2.7 GEL
    const qty = Number(c.quantity) || 1;
    const rate = Number(c.rate) || 0;
    if (c.code && rate > 0) {
      rates[c.code.toUpperCase()] = rate / qty;
    }
  }
  rates.GEL = 1;

  cachedRates = rates;
  cachedAt = now;
  return rates;
}

/**
 * Returns the list of supported currency codes (GEL first, then alphabetical).
 */
export async function fetchCurrencyList() {
  try {
    const rates = await fetchNbgRates();
    const codes = Object.keys(rates).sort();
    return ["GEL", ...codes.filter((c) => c !== "GEL")];
  } catch {
    return ["GEL", "USD", "EUR", "RUB", "GBP"];
  }
}

/**
 * Exchange rate between two currencies.
 * Returns `toRate / fromRate` where rate is GEL per unit.
 * Example: USD -> EUR = rate_usd_in_gel / rate_eur_in_gel
 * GEL -> GEL = 1
 */
export async function getExchangeRate(from, to) {
  const f = (from || "").toUpperCase();
  const t = (to || "").toUpperCase();
  if (!f || !t) return 1;
  if (f === t) return 1;

  const rates = await fetchNbgRates();
  const fromRate = rates[f]; // GEL per 1 unit of `from`
  const toRate = rates[t];
  if (!fromRate || !toRate) return 1;
  // how many `to` units in 1 `from` unit = fromRate (GEL) / toRate (GEL per `to`)
  return fromRate / toRate;
}
